module.exports = "/assets/4f1609f38041eef40b066284e945835d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DG.png
// module id = 1300
// module chunks = 0